// #region agent log
// Temporary debug-session instrumentation (session 9286cf). Browser posts to
// the same-origin API relay, which forwards to the local ingest server.
export const dbg = (location, message, data, hypothesisId) => {
  try {
    fetch('/api/debug-log', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId: '9286cf', runId: 'run1', hypothesisId, location, message, data, timestamp: Date.now() }),
    }).catch(() => {});
  } catch (e) { /* never break the app for logging */ }
};
// #endregion
